export default function stripeToOurs(a) {
  if (a.line1 && !a.address1) a.address1 = a.line1
  if (a.postal_code && !a.zip) a.zip = a.postal_code
  if (a.line2 && !a.address2) a.address2 = a.line2
  delete a.line1
  delete a.line2
  delete a.postal_code
  return a
}